/* eslint-disable */
import _ from 'underscore';
import pageContext from '@bingads-webui-static-legacy/page-context';
var Permissions = pageContext.Permissions;
export default {
  dataDateRanges: {
    'Today': 'Today',
    'Yesterday': 'Yesterday',
    'ThisWeekFromSun': 'ThisWeekFromSun',
    'ThisWeekFromMon': 'ThisWeekFromMon',
    'Last7Days': 'LastSevenDays',
    'LastWeekStartingSun': 'LastWeekStartingSun',
    'LastWeekStartingMon': 'LastWeekStartingMon',
    'LastBusinessWeek': 'LastBusinessWeek',
    'Last14Days': 'LastFourteenDays',
    'ThisMonth': 'ThisMonth',
    'Last30Days': 'LastThirtyDays',
    'LastMonth': 'LastMonth',
    'Last3Month': 'LastThreeMonths',
    'Last6Month': 'LastSixMonths',
    'ThisYear': 'ThisYear',
    'LastYear': 'LastYear',
    'AllTime': 'AllTime'
  },
  frequencyGrain: {
    'Hourly': 4,
    'Daily': 0,
    'Weekly': 1,
    'Monthly': 2,
    'Once': 3
  },
  weeklyOptions: {
    'Monday': 1,
    'Tuesday': 2,
    'Wednesday': 3,
    'Thursday': 4,
    'Friday': 5,
    'Saturday': 6,
    'Sunday': 0
  },
  dailyOptions: {
    '12AM': 0,
    '1AM': 1,
    '2AM': 2,
    '3AM': 3,
    '4AM': 4,
    '5AM': 5,
    '6AM': 6,
    '7AM': 7,
    '8AM': 8,
    '9AM': 9,
    '10AM': 10,
    '11AM': 11,
    '12PM': 12,
    '1PM': 13,
    '2PM': 14,
    '3PM': 15,
    '4PM': 16,
    '5PM': 17,
    '6PM': 18,
    '7PM': 19,
    '8PM': 20,
    '9PM': 21,
    '10PM': 22,
    '11PM': 23
  },
  emailOptions: {
    'Always': 'Always',
    'OnChangeOrError': 'OnChange, OnError',
    'OnError': 'OnError',
    'None': 'None'
  },
  scopeOptions: {
    'Selected': 0,
    'AllEnabled': 1,
    'AllButRemoved': 2,
    'SelectCampaignOrAdGroup': 3
  },
  entityRelatedOptions: {
    'EnabledStatusFilterValue': {
      'Campaign': ['121', '126'],
      'Ad': ['1'],
      'AdGroup': ['141', '126'],
      'Keyword': ['161']
    },
    'EnabledStatusFilterColumn': {
      'Campaign': 'CampaignStatus',
      'Ad': 'AdUiDisplayStatus',
      'AdGroup': 'AdGroupStatus',
      'Keyword': 'KeywordStatus'
    },
    'PauseActionValue': {
      'Campaign': 'UserPaused',
      'Ad': 'Paused',
      'AdGroup': 'Paused',
      'Keyword': 'Paused'
    },
    'EntityGridFilterName': {
      'Campaign': 'campaignsFilters',
      'Ad': 'adFilters',
      'AdGroup': 'adGroupFilters',
      'Keyword': 'gridFilter'
    },
    'PreviewEntityKey': {
      'Campaign': 'CampaignName',
      'Ad': 'AdTitle',
      'AdGroup': 'AdgroupName',
      'Keyword': 'Keyword'
    }
  },
  campaignFilterData: {
    'Filters': null,
    'UseOrFilter': false,
    'DataDomain': 'Campaign',
    'ColumnToFilterTypeMapping': {
      'CampaignId': 'NumericValue',
      'CTR': 'NumericValue',
      'Clicks': 'NumericValue',
      'ClickShare': 'NumericValue',
      'TotalCost': 'NumericValue',
      'Impressions': 'NumericValue',
      'TotalEffectiveCost': 'CurrencyValue',
      'Conversions': 'NumericValue',
      'AverageCPC': 'CurrencyValue',
      'AverageCPM': 'CurrencyValue',
      'AveragePosition': 'NumericValue',
      'CPA': 'NumericValue',
      'RevenueOnAdSpend': 'NumericValue',
      'ConversionRate': 'NumericValue',
      'AdvertiserReportedRevenue': 'NumericValue',
      'AverageCPP': 'NumericValue',
      'ManualCalls': 'NumericValue',
      'PhoneSpent': 'NumericValue',
      'PhoneImpressions': 'NumericValue',
      'PhoneThroughRate': 'NumericValue',
      'ClickAndPhoneSpent': 'NumericValue',
      'ClickCalls': 'NumericValue',
      'CampaignName': 'StringValue',
      'CampaignStatus': 'EnumSelector',
      'DeliveryStatus': 'EnumSelector',
      'CampaignCampaignType': 'EnumSelector',
      'CampaignIsLastImported': 'BooleanValue',
      'CampaignBudgetAmount': 'NumericValue',
      'CampaignLanguages': 'IdentitySelector',
      'QualityScore': 'NumericValue',
      'HasAuctionInsight': 'BooleanValue',
      'Labels': 'IdentitySelector',
      'DisplayBiddingStrategyType': 'EnumSelector',
      'AuctionWonPercent': 'NumericValue',
      'AuctionLostToBudgetPercent': 'NumericValue',
      'AuctionLostToRankPercent': 'NumericValue',
      'TopImpressionRate': 'NumericValue',
      'AbsoluteTopImpressionRate': 'NumericValue',
      'ExactMatchImpressionSharePercent': 'NumericValue',
      'TopImpressionSharePercent': 'NumericValue',
      'TopISLostToBudgetPercent': 'NumericValue',
      'TopISLostToRankPercent': 'NumericValue',
      'AbsoluteTopImpressionSharePercent': 'NumericValue',
      'AbsoluteTopISLostToBudgetPercent': 'NumericValue',
      'AbsoluteTopISLostToRankPercent': 'NumericValue'
    },
    'FilterTypeToOperatorMapping': {
      'StringValue': ['Contains', 'DoesNotContain', 'BeginsWith', 'EndsWith', 'Equal', 'NotEqual'],
      'ExactStringValue': ['Equal'],
      'PartialStringValue': ['Contains'],
      'RangeSelector': ['Between'],
      'EnumSelector': ['EnumSelection'],
      'CurrencyValue': ['Greater', 'GreaterOrEqual', 'Less', 'LessOrEqual', 'Equal', 'NotEqual'],
      'NumericValue': ['Greater', 'GreaterOrEqual', 'Less', 'LessOrEqual', 'Equal', 'NotEqual'],
      'DateValue': ['Equal', 'NotEqual', 'Greater', 'GreaterOrEqual', 'Less', 'LessOrEqual', 'Between'],
      'IdentityValue': ['Equal'],
      'IdentitySelector': ['ContainsAll', 'ContainsAny', 'ContainsNone'],
      'BooleanValue': ['Equal']
    },
    'ColumnToEnumMapping': {
      'CampaignStatus': 'CampaignStatus',
      'DeliveryStatus': 'DeliveryStatus',
      'CampaignCampaignType': 'CampaignType',
      'DisplayBiddingStrategyType': 'BiddingStrategyType'
    },
    'EnumTypeToAvailableValuesMapping': {
      'CampaignStatus': [{
        'Key': '121',
        'Value': 'Active'
      }, {
        'Key': '123',
        'Value': 'Deleted'
      }, {
        'Key': '124',
        'Value': 'UserPaused'
      }, {
        'Key': '126',
        'Value': 'BudgetPaused'
      }, {
        'Key': '127',
        'Value': 'BudgetUserPaused'
      }, {
        'Key': '8',
        'Value': 'Suspended'
      }],
      'DeliveryStatus': [{
        'Key': '40',
        'Value': 'InvalidFinancialStatusOther'
      }, {
        'Key': '50',
        'Value': 'CampaignBudgetPaused'
      }, {
        'Key': '90',
        'Value': 'CampaignUserPaused'
      }, {
        'Key': '2147483647',
        'Value': 'Eligible'
      }, {
        'Key': '49',
        'Value': 'CampaignSuspended'
      }, {
        'Key': '1001',
        'Value': 'BudgetSuggestions'
      }, {
        'Key': '2000',
        'Value': 'New'
      }, {
        'Key': '190',
        'Value': 'AutoBiddingLimitedByNotEnoughConversions'
      }, {
        'Key': '107',
        'Value': 'NoEligibleAdGroups'
      }],
      'CampaignType': [{
        'Key': '1',
        'Value': 'Default'
      }, {
        'Key': '2',
        'Value': 'Shopping'
      }, {
        'Key': '4',
        'Value': 'DynamicSearchAds'
      }],
      'BiddingStrategyType': _.compact([{
        'Key': '1',
        'Value': 'ManualCpc'
      }, {
        'Key': '2',
        'Value': 'MaxClicks'
      }, {
        'Key': '3',
        'Value': 'MaxConversions'
      }, {
        'Key': '4',
        'Value': 'TargetCpa'
      }, {
        'Key': '5',
        'Value': 'EnhancedCpc'
      }, (Permissions.IsCampaignTargetROASBidStrategyEnabled || Permissions.IsNewCampaignTargetROASBidStrategyEnabled) && ({
        'Key': '6',
        'Value': 'TargetRoas'
      }), (Permissions.IsMaximizeConversionValueEnabled || Permissions.IsSmartShoppingCampaignEnabled) && ({
        'Key': '8',
        'Value': 'MaxConversionValue'
      }), Permissions.IsTargetImpressionShareEnabled && ({
        'Key': '9',
        'Value': 'TargetImpressionShare'
      })])
    },
    'QuickFilterColumn': 'CampaignName',
    'QuickFilterOperator': 'Contains',
    'SelectedFilter': null,
    'FilterByAdgroup': false,
    'OverThresholdFilter': false,
    'ClientLocalization': true
  },
  adFilterData: {
    'Filters': null,
    'UseOrFilter': false,
    'DataDomain': 'Ad',
    'ColumnToFilterTypeMapping': {
      'CTR': 'NumericValue',
      'Clicks': 'NumericValue',
      'Impressions': 'NumericValue',
      'TotalEffectiveCost': 'CurrencyValue',
      'Conversions': 'NumericValue',
      'AverageCPC': 'CurrencyValue',
      'AveragePosition': 'NumericValue',
      'CPA': 'NumericValue',
      'RevenueOnAdSpend': 'NumericValue',
      'ConversionRate': 'NumericValue',
      'AdvertiserReportedRevenue': 'NumericValue',
      'AdId': 'NumericValue',
      'CampaignName': 'StringValue',
      'AdAdGroupName': 'StringValue',
      'AdTitle': 'StringValue',
      'AdDescription': 'StringValue',
      'AdDisplayUrl': 'StringValue',
      'AdDestinationUrl': 'StringValue',
      'DeliveryStatus': 'EnumSelector',
      'AdType': 'EnumSelector',
      'AdUiDisplayStatus': 'EnumSelector',
      'DevicePreference': 'EnumSelector',
      'AdIsLastImported': 'BooleanValue',
      'CampaignId': 'NumericValue',
      'AdGroupId': 'NumericValue',
      'Labels': 'IdentitySelector',
      'FinalUrls': 'ContainsOrNotContainsStringValue',
      'MobileFinalUrls': 'ContainsOrNotContainsStringValue',
      'TrackingTemplate': 'ExactOrContainsOrNotContainsOrStartsWithStringValue',
      'FinalUrlSuffix': 'ExactOrContainsOrNotContainsOrStartsWithStringValue',
      'AbsoluteTopImpressionSharePercent': 'NumericValue',
      'AdsByBing': 'BooleanValue'
    },
    'FilterTypeToOperatorMapping': {
      'StringValue': ['Contains', 'DoesNotContain', 'BeginsWith', 'EndsWith', 'Equal', 'NotEqual'],
      'ContainsOrNotContainsStringValue': ['Contains', 'DoesNotContain'],
      'ExactOrContainsOrNotContainsOrStartsWithStringValue': ['Contains', 'DoesNotContain', 'BeginsWith', 'Equal'],
      'RangeSelector': ['Between'],
      'EnumSelector': ['EnumSelection'],
      'CurrencyValue': ['Greater', 'GreaterOrEqual', 'Less', 'LessOrEqual', 'Equal', 'NotEqual'],
      'NumericValue': ['Greater', 'GreaterOrEqual', 'Less', 'LessOrEqual', 'Equal', 'NotEqual'],
      'DateValue': ['Equal', 'NotEqual', 'Greater', 'GreaterOrEqual', 'Less', 'LessOrEqual', 'Between'],
      'IdentityValue': ['Equal'],
      'IdentitySelector': ['ContainsAll', 'ContainsAny', 'ContainsNone'],
      'BooleanValue': ['Equal'],
      'ExactStringValue': ['Equal'],
      'PartialStringValue': ['Contains']
    },
    'ColumnToEnumMapping': {
      'DeliveryStatus': 'DeliveryStatus',
      'AdType': 'AdType',
      'AdUiDisplayStatus': 'UiDisplayStatus',
      'DevicePreference': 'DevicePreference'
    },
    'EnumTypeToAvailableValuesMapping': {
      'DeliveryStatus': [{
        'Key': '40',
        'Value': 'InvalidFinancialStatusOther'
      }, {
        'Key': '50',
        'Value': 'CampaignBudgetPaused'
      }, {
        'Key': '60',
        'Value': 'AdGroupExpired'
      }, {
        'Key': '62',
        'Value': 'AdGroupDraft'
      }, {
        'Key': '64',
        'Value': 'CamAssetRejected'
      }, {
        'Key': '66',
        'Value': 'CamAssetDeleted'
      }, {
        'Key': '70',
        'Value': 'EditorialRejected'
      }, {
        'Key': '75',
        'Value': 'EditorialUnderAppeal'
      }, {
        'Key': '76',
        'Value': 'UrlInvalid'
      }, {
        'Key': '77',
        'Value': 'ApplicationNotFound'
      }, {
        'Key': '78',
        'Value': 'ApplicationDestinationUrlMismatch'
      }, {
        'Key': '79',
        'Value': 'PendingMetadataSync'
      }, {
        'Key': '80',
        'Value': 'EditorialPending'
      }, {
        'Key': '90',
        'Value': 'CampaignUserPaused'
      }, {
        'Key': '100',
        'Value': 'AdGroupUserPaused'
      }, {
        'Key': '110',
        'Value': 'AdUserPaused'
      }, {
        'Key': '200',
        'Value': 'EditorialApprovedLimited'
      }, {
        'Key': '2147483647',
        'Value': 'Eligible'
      }, {
        'Key': '1103',
        'Value': 'AdExtensionNotPresent'
      }, {
        'Key': '1105',
        'Value': 'AdExtensionAssociationDeleted'
      }, {
        'Key': '49',
        'Value': 'CampaignSuspended'
      }, {
        'Key': '2000',
        'Value': 'New'
      }],
      'AdType': [{
        'Key': '1',
        'Value': 'Text'
      }, {
        'Key': '2',
        'Value': 'Mobile'
      }, {
        'Key': '4',
        'Value': 'BannerImage'
      }, {
        'Key': '16',
        'Value': 'RichMedia'
      }, {
        'Key': '32',
        'Value': 'ThirdPartyServedAsset'
      }, {
        'Key': '64',
        'Value': 'RichSearchAd'
      }, {
        'Key': '128',
        'Value': 'Product'
      }, {
        'Key': '256',
        'Value': 'AppInstall'
      }, {
        'Key': '1024',
        'Value': 'ExpandedText'
      }, {
        'Key': '512',
        'Value': 'DynamicSearch'
      }],
      'UiDisplayStatus': [{
        'Key': '0',
        'Value': 'Inactive'
      }, {
        'Key': '1',
        'Value': 'Active'
      }, {
        'Key': '2',
        'Value': 'Paused'
      }, {
        'Key': '3',
        'Value': 'Deleted'
      }],
      'DevicePreference': [{
        'Key': '2',
        'Value': 'Mobile'
      }, {
        'Key': '0',
        'Value': 'All'
      }]
    },
    'QuickFilterColumn': null,
    'QuickFilterOperator': null,
    'SelectedFilter': null,
    'FilterByAdgroup': true,
    'OverThresholdFilter': false,
    'ClientLocalization': true
  },
  adGroupFilterData: {
    'Filters': null,
    'UseOrFilter': false,
    'DataDomain': 'AdGroup',
    'ColumnToFilterTypeMapping': {
      'CTR': 'NumericValue',
      'Clicks': 'NumericValue',
      'ClickShare': 'NumericValue',
      'TotalCost': 'NumericValue',
      'Impressions': 'NumericValue',
      'TotalEffectiveCost': 'CurrencyValue',
      'Conversions': 'NumericValue',
      'AverageCPC': 'CurrencyValue',
      'AverageCPM': 'CurrencyValue',
      'AveragePosition': 'NumericValue',
      'CPA': 'NumericValue',
      'RevenueOnAdSpend': 'NumericValue',
      'ConversionRate': 'NumericValue',
      'AdvertiserReportedRevenue': 'NumericValue',
      'AverageCPP': 'NumericValue',
      'ManualCalls': 'NumericValue',
      'PhoneSpent': 'NumericValue',
      'PhoneImpressions': 'NumericValue',
      'PhoneThroughRate': 'NumericValue',
      'ClickAndPhoneSpent': 'NumericValue',
      'ClickCalls': 'NumericValue',
      'CampaignName': 'StringValue',
      'AdGroupName': 'StringValue',
      'AdGroupStartDate': 'DateValue',
      'AdGroupEndDate': 'DateValue',
      'Language': 'DropdownSelector',
      'AdGroupDefaultSearchBid': 'CurrencyValue',
      'DeliveryStatus': 'EnumSelector',
      'AdGroupCallTrackingStatus': 'EnumSelector',
      'AdGroupStatus': 'EnumSelector',
      'AdGroupIsLastImported': 'BooleanValue',
      'CampaignId': 'NumericValue',
      'AdGroupId': 'NumericValue',
      'QualityScore': 'NumericValue',
      'HasAuctionInsight': 'BooleanValue',
      'Labels': 'IdentitySelector',
      'DisplayBiddingStrategyType': 'EnumSelector',
      'AuctionWonPercent': 'NumericValue',
      'AuctionLostToBudgetPercent': 'NumericValue',
      'AuctionLostToRankPercent': 'NumericValue',
      'TopImpressionRate': 'NumericValue',
      'AbsoluteTopImpressionRate': 'NumericValue',
      'ExactMatchImpressionSharePercent': 'NumericValue',
      'TopImpressionSharePercent': 'NumericValue',
      'TopISLostToBudgetPercent': 'NumericValue',
      'TopISLostToRankPercent': 'NumericValue',
      'AbsoluteTopImpressionSharePercent': 'NumericValue',
      'AbsoluteTopISLostToBudgetPercent': 'NumericValue',
      'AbsoluteTopISLostToRankPercent': 'NumericValue'
    },
    'FilterTypeToOperatorMapping': {
      'StringValue': ['Contains', 'DoesNotContain', 'BeginsWith', 'EndsWith', 'Equal', 'NotEqual'],
      'RangeSelector': ['Between'],
      'EnumSelector': ['EnumSelection'],
      'DropdownSelector': ['EnumSelection'],
      'CurrencyValue': ['Greater', 'GreaterOrEqual', 'Less', 'LessOrEqual', 'Equal', 'NotEqual'],
      'NumericValue': ['Greater', 'GreaterOrEqual', 'Less', 'LessOrEqual', 'Equal', 'NotEqual'],
      'DateValue': ['Equal', 'NotEqual', 'Greater', 'GreaterOrEqual', 'Less', 'LessOrEqual', 'Between'],
      'IdentitySelector': ['ContainsAll', 'ContainsAny', 'ContainsNone'],
      'IdentityValue': ['Equal'],
      'BooleanValue': ['Equal'],
      'ExactStringValue': ['Equal'],
      'PartialStringValue': ['Contains']
    },
    'ColumnToEnumMapping': {
      'DeliveryStatus': 'DeliveryStatus',
      'Language': 'Language',
      'AdGroupCallTrackingStatus': 'AdGroupCallTrackingStatus',
      'AdGroupStatus': 'AdGroupStatus',
      'DisplayBiddingStrategyType': 'BiddingStrategyType'
    },
    'EnumTypeToAvailableValuesMapping': {
      'Language': [{
        'Key': null,
        'Value': null
      }, {
        'Key': '0',
        'Value': 'None'
      }, {
        'Key': '7',
        'Value': 'Arabic'
      }, {
        'Key': '28',
        'Value': 'Danish'
      }, {
        'Key': '29',
        'Value': 'Dutch'
      }, {
        'Key': '40',
        'Value': 'German'
      }, {
        'Key': '30',
        'Value': 'English'
      }, {
        'Key': '35',
        'Value': 'Finnish'
      }, {
        'Key': '36',
        'Value': 'French'
      }, {
        'Key': '55',
        'Value': 'Italian'
      }, {
        'Key': '82',
        'Value': 'Norwegian'
      }, {
        'Key': '88',
        'Value': 'Portuguese'
      }, {
        'Key': '109',
        'Value': 'Spanish'
      }, {
        'Key': '112',
        'Value': 'Swedish'
      }, {
        'Key': '24',
        'Value': 'TraditionalChinese'
      }, {
        'Key': '137',
        'Value': 'SimplifiedChinese'
      }, {
        'Key': '41',
        'Value': 'Greek'
      }, {
        'Key': '87',
        'Value': 'Polish'
      }, {
        'Key': '19',
        'Value': 'Bulgarian'
      }, {
        'Key': '27',
        'Value': 'Czech'
      }, {
        'Key': '32',
        'Value': 'Estonian'
      }, {
        'Key': '26',
        'Value': 'Croatian'
      }, {
        'Key': '48',
        'Value': 'Hungarian'
      }, {
        'Key': '70',
        'Value': 'Lithuanian'
      }, {
        'Key': '68',
        'Value': 'Latvian'
      }, {
        'Key': '75',
        'Value': 'Maltese'
      }, {
        'Key': '92',
        'Value': 'Romanian'
      }, {
        'Key': '106',
        'Value': 'Slovak'
      }, {
        'Key': '107',
        'Value': 'Slovenian'
      }, {
        'Key': '123',
        'Value': 'Turkish'
      }, {
        'Key': '98',
        'Value': 'Serbian'
      }, {
        'Key': '138',
        'Value': 'Bosnian'
      }, {
        'Key': '5',
        'Value': 'Albanian'
      }, {
        'Key': '71',
        'Value': 'Macedonian'
      }, {
        'Key': '49',
        'Value': 'Icelandic'
      }, {
        'Key': '56',
        'Value': 'Japanese'
      }, {
        'Key': '46',
        'Value': 'Hebrew'
      }, {
        'Key': '93',
        'Value': 'Russian'
      }, {
        'Key': '47',
        'Value': 'Hindi'
      }, {
        'Key': '73',
        'Value': 'Malay'
      }, {
        'Key': '118',
        'Value': 'Thai'
      }, {
        'Key': '50',
        'Value': 'Indonesian'
      }, {
        'Key': '113',
        'Value': 'Tagalog'
      }, {
        'Key': '126',
        'Value': 'Vietnamese'
      }],
      'DeliveryStatus': [{
        'Key': '40',
        'Value': 'InvalidFinancialStatusOther'
      }, {
        'Key': '50',
        'Value': 'CampaignBudgetPaused'
      }, {
        'Key': '60',
        'Value': 'AdGroupExpired'
      }, {
        'Key': '62',
        'Value': 'AdGroupDraft'
      }, {
        'Key': '90',
        'Value': 'CampaignUserPaused'
      }, {
        'Key': '100',
        'Value': 'AdGroupUserPaused'
      }, {
        'Key': '2147483647',
        'Value': 'Eligible'
      }, {
        'Key': '49',
        'Value': 'CampaignSuspended'
      }, {
        'Key': '2000',
        'Value': 'New'
      }, {
        'Key': '67',
        'Value': 'AdGroupTargetingTooNarrow'
      }, {
        'Key': '91',
        'Value': 'AdGroupPrivacyPending'
      }, {
        'Key': '105',
        'Value': 'NoEligibleAds'
      }, {
        'Key': '106',
        'Value': 'NoEligibleKeywords'
      }],
      'AdGroupCallTrackingStatus': [{
        'Key': '1',
        'Value': 'Eligible'
      }, {
        'Key': '2',
        'Value': 'NotEligible'
      }, {
        'Key': '0',
        'Value': 'NotApplicable'
      }, {
        'Key': '3',
        'Value': 'ProvisioningPending'
      }, {
        'Key': '4',
        'Value': 'Provisioned'
      }],
      'AdGroupStatus': [{
        'Key': '140',
        'Value': 'Draft'
      }, {
        'Key': '141',
        'Value': 'Active'
      }, {
        'Key': '143',
        'Value': 'Deleted'
      }, {
        'Key': '144',
        'Value': 'Paused'
      }, {
        'Key': '150',
        'Value': 'Expired'
      }, {
        'Key': '124',
        'Value': 'CampaignUserPaused'
      }, {
        'Key': '126',
        'Value': 'CampaignBudgetPaused'
      }, {
        'Key': '127',
        'Value': 'CampaignBudgetUserPaused'
      }],
      'BiddingStrategyType': _.compact([{
        'Key': '1',
        'Value': 'ManualCpc'
      }, {
        'Key': '2',
        'Value': 'MaxClicks'
      }, {
        'Key': '3',
        'Value': 'MaxConversions'
      }, {
        'Key': '4',
        'Value': 'TargetCpa'
      }, {
        'Key': '5',
        'Value': 'EnhancedCpc'
      }, (Permissions.IsCampaignTargetROASBidStrategyEnabled || Permissions.IsNewCampaignTargetROASBidStrategyEnabled) && ({
        'Key': '6',
        'Value': 'TargetRoas'
      }), (Permissions.IsMaximizeConversionValueEnabled || Permissions.IsSmartShoppingCampaignEnabled) && ({
        'Key': '8',
        'Value': 'MaxConversionValue'
      }), Permissions.IsTargetImpressionShareEnabled && ({
        'Key': '9',
        'Value': 'TargetImpressionShare'
      })])
    },
    'QuickFilterColumn': 'AdGroupName',
    'QuickFilterOperator': 'Contains',
    'SelectedFilter': null,
    'FilterByAdgroup': false,
    'OverThresholdFilter': false,
    'ClientLocalization': true
  },
  keywordFilterData: {
    'Filters': null,
    'UseOrFilter': false,
    'DataDomain': 'Keyword',
    'ColumnToFilterTypeMapping': {
      'CTR': 'NumericValue',
      'Clicks': 'NumericValue',
      'Impressions': 'NumericValue',
      'TotalEffectiveCost': 'CurrencyValue',
      'Conversions': 'NumericValue',
      'AverageCPC': 'CurrencyValue',
      'AverageCPM': 'CurrencyValue',
      'AveragePosition': 'NumericValue',
      'CPA': 'NumericValue',
      'RevenueOnAdSpend': 'NumericValue',
      'ConversionRate': 'NumericValue',
      'AdvertiserReportedRevenue': 'NumericValue',
      'FirstPageBid': 'NumericValue',
      'MainlineBid': 'NumericValue',
      'BestPositionBid': 'NumericValue',
      'KeywordName': 'StringValue',
      'DeliveryStatus': 'EnumSelector',
      'KeywordStatus': 'EnumSelector',
      'MatchType': 'EnumSelector',
      'QualityScore': 'NumericValue',
      'OrderItemBid': 'NumericValue',
      'CampaignName': 'StringValue',
      'KeywordAdGroupName': 'StringValue',
      'KeywordIsLastImported': 'BooleanValue',
      'CampaignId': 'NumericValue',
      'AdGroupId': 'NumericValue',
      'HasAuctionInsight': 'BooleanValue',
      'OrderItemId': 'NumericValue',
      'Labels': 'IdentitySelector',
      'DisplayBiddingStrategyType': 'EnumSelector',
      'AuctionWonPercent': 'NumericValue',
      'AuctionLostToBudgetPercent': 'NumericValue',
      'AuctionLostToRankPercent': 'NumericValue',
      'ClickShare': 'NumericValue',
      'FinalUrls': 'ContainsOrNotContainsStringValue',
      'MobileFinalUrls': 'ContainsOrNotContainsStringValue',
      'TrackingTemplate': 'ExactOrContainsOrNotContainsOrStartsWithStringValue',
      'FinalUrlSuffix': 'ExactOrContainsOrNotContainsOrStartsWithStringValue',
      'TopImpressionRate': 'NumericValue',
      'AbsoluteTopImpressionRate': 'NumericValue',
      'ExactMatchImpressionSharePercent': 'NumericValue',
      'TopImpressionSharePercent': 'NumericValue',
      'TopISLostToBudgetPercent': 'NumericValue',
      'TopISLostToRankPercent': 'NumericValue',
      'AbsoluteTopImpressionSharePercent': 'NumericValue',
      'AbsoluteTopISLostToBudgetPercent': 'NumericValue',
      'AbsoluteTopISLostToRankPercent': 'NumericValue'
    },
    'FilterTypeToOperatorMapping': {
      'StringValue': ['Contains', 'DoesNotContain', 'BeginsWith', 'EndsWith', 'Equal', 'NotEqual'],
      'ContainsOrNotContainsStringValue': ['Contains', 'DoesNotContain'],
      'ExactOrContainsOrNotContainsOrStartsWithStringValue': ['Contains', 'DoesNotContain', 'BeginsWith', 'Equal'],
      'RangeSelector': ['Between'],
      'EnumSelector': ['EnumSelection'],
      'CurrencyValue': ['Greater', 'GreaterOrEqual', 'Less', 'LessOrEqual', 'Equal', 'NotEqual'],
      'NumericValue': ['Greater', 'GreaterOrEqual', 'Less', 'LessOrEqual', 'Equal', 'NotEqual'],
      'DateValue': ['Equal', 'NotEqual', 'Greater', 'GreaterOrEqual', 'Less', 'LessOrEqual', 'Between'],
      'IdentityValue': ['Equal'],
      'IdentitySelector': ['ContainsAll', 'ContainsAny', 'ContainsNone'],
      'BooleanValue': ['Equal'],
      'ExactStringValue': ['Equal'],
      'PartialStringValue': ['Contains']
    },
    'ColumnToEnumMapping': {
      'DeliveryStatus': 'DeliveryStatus',
      'KeywordStatus': 'KeywordStatus',
      'MatchType': 'MatchType',
      'DisplayBiddingStrategyType': 'BiddingStrategyType'
    },
    'EnumTypeToAvailableValuesMapping': {
      'DeliveryStatus': [{
        'Key': '40',
        'Value': 'InvalidFinancialStatusOther'
      }, {
        'Key': '50',
        'Value': 'CampaignBudgetPaused'
      }, {
        'Key': '60',
        'Value': 'AdGroupExpired'
      }, {
        'Key': '62',
        'Value': 'AdGroupDraft'
      }, {
        'Key': '70',
        'Value': 'EditorialRejected'
      }, {
        'Key': '75',
        'Value': 'EditorialUnderAppeal'
      }, {
        'Key': '80',
        'Value': 'EditorialPending'
      }, {
        'Key': '90',
        'Value': 'CampaignUserPaused'
      }, {
        'Key': '100',
        'Value': 'AdGroupUserPaused'
      }, {
        'Key': '130',
        'Value': 'NegativeKeywordConflicts'
      }, {
        'Key': '135',
        'Value': 'PartialNegativeKeywordConflicts'
      }, {
        'Key': '200',
        'Value': 'EditorialApprovedLimited'
      }, {
        'Key': '300',
        'Value': 'LowSupply'
      }, {
        'Key': '400',
        'Value': 'LowQuality'
      }, {
        'Key': '500',
        'Value': 'BidBelowFirstPageBid'
      }, {
        'Key': '2000',
        'Value': 'New'
      }, {
        'Key': '2147483647',
        'Value': 'Eligible'
      }, {
        'Key': '49',
        'Value': 'CampaignSuspended'
      }],
      'KeywordStatus': [{
        'Key': '161',
        'Value': 'Active'
      }, {
        'Key': '162',
        'Value': 'Paused'
      }, {
        'Key': '163',
        'Value': 'Deleted'
      }],
      'MatchType': [{
        'Key': '1',
        'Value': 'Exact'
      }, {
        'Key': '2',
        'Value': 'Phrase'
      }, {
        'Key': '3',
        'Value': 'Broad'
      }],
      'BiddingStrategyType': _.compact([{
        'Key': '1',
        'Value': 'ManualCpc'
      }, {
        'Key': '2',
        'Value': 'MaxClicks'
      }, {
        'Key': '3',
        'Value': 'MaxConversions'
      }, {
        'Key': '4',
        'Value': 'TargetCpa'
      }, {
        'Key': '5',
        'Value': 'EnhancedCpc'
      }, (Permissions.IsCampaignTargetROASBidStrategyEnabled || Permissions.IsNewCampaignTargetROASBidStrategyEnabled) && ({
        'Key': '6',
        'Value': 'TargetRoas'
      }), (Permissions.IsMaximizeConversionValueEnabled || Permissions.IsSmartShoppingCampaignEnabled) && ({
        'Key': '8',
        'Value': 'MaxConversionValue'
      }), Permissions.IsTargetImpressionShareEnabled && ({
        'Key': '9',
        'Value': 'TargetImpressionShare'
      })])
    },
    'QuickFilterColumn': 'KeywordName',
    'QuickFilterOperator': 'Contains',
    'SelectedFilter': null,
    'FilterByAdgroup': true,
    'OverThresholdFilter': false,
    'ClientLocalization': true
  }
};

